'use client';

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { createContext, use, useCallback, useMemo, useState } from 'react';
import { CartDrawer, type CartDrawerAlert } from '../molecules/cart-drawer/cart-drawer.tsx';
interface CartDrawerContextValue {
  openCartDrawer: (options?: {
    alert?: CartDrawerAlert;
  }) => void;
  closeCartDrawer: () => void;
  clearCartDrawerAlert: () => void;
}
const CartDrawerContext = createContext<CartDrawerContextValue | null>(null);
export const CartDrawerProvider = t0 => {
  const $ = _c(9);
  const {
    children
  } = t0;
  const [open, setOpen] = useState(false);
  const [alert, setAlert] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = nextIsOpen => {
      if (!nextIsOpen) {
        setAlert(null);
      }
      setOpen(nextIsOpen);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleOpenChange = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      openCartDrawer: options => {
        setAlert(options?.alert ?? null);
        setOpen(true);
      },
      closeCartDrawer: () => handleOpenChange(false),
      clearCartDrawerAlert: () => setAlert(null)
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const value = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setAlert(null);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== alert || $[4] !== open) {
    t4 = <CartDrawer open={open} onOpenChange={handleOpenChange} alert={alert} onAlertClose={t3} />;
    $[3] = alert;
    $[4] = open;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== t4) {
    t5 = <CartDrawerContext value={value}>{children}{t4}</CartDrawerContext>;
    $[6] = children;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export const useCartDrawer = () => {
  const context = use(CartDrawerContext);
  if (!context) {
    throw new Error('useCartDrawer must be used within CartDrawerProvider');
  }
  return context;
};